import {Util, UUID} from './util'

interface Subscriber {
  id: UUID
  cb(): void
  message: string
}

export class PubSub {
  /**
   * message -> set(listener.id)
   */
  private static listeners: Map<string, Set<UUID>> = new Map()
  /**
   * listener.id -> listener
   */
  private static index: Map<UUID, Subscriber> = new Map()

  public static subscribe(message: string, cb: () => void): UUID {
    let all = PubSub.listeners.get(message)
    if (!all) {
      all = new Set()
      PubSub.listeners.set(message, all)
    }
    const id = Util.UUID()
    all.add(id)
    PubSub.index.set(id, {id, cb, message})
    return id
  }

  public static unsubscribe(id: UUID): void {
    const lsn = PubSub.index.get(id)
    if (!lsn) {
      return
    }
    PubSub.index.delete(id)
    const all = PubSub.listeners.get(lsn.message)
    if (!all) {
      return
    }
    all.delete(id)
    if (all.size === 0) {
      PubSub.listeners.delete(lsn.message)
    }
  }

  public static publish(message: string): void {
    const all = PubSub.listeners.get(message)
    if (!all) {
      return
    }
    ;[...all].forEach(id => {
      const lsn = PubSub.index.get(id)
      if (lsn && lsn.cb) {
        lsn.cb()
      }
    })
  }
}
